import { SET_ROUTE } from './types';

export default (payload: unknown) => ({
  type: SET_ROUTE,
  payload,
});
